import React from "react";
import {getInvoicesTable} from "../../Util/TableHelpers/invoiceTableHelper";
import TableWrapper from "../Table/tableWrapper";
import {useSelector} from "react-redux";

const InvoicesTableHeader = ["Status", "Date", "Amount USD", " "];
const NoInvoicesText = "You do not have any invoices"

const InvoicesTableSection = () => {
    const partnerInvoices = useSelector(state => state.partnerInvoices);
    const option = {
        minWidth: false
    }
    if (partnerInvoices === null) return <></>

    const tableBodyArr = getInvoicesTable(partnerInvoices.getInvoicesArr());

    return (
        <div className="row mt-4">
            <span className="sub-title mt-3">Invoices</span>
            <TableWrapper tableHeaderArr={InvoicesTableHeader} tableBodyArr={tableBodyArr} errorText={NoInvoicesText}
                          option={option}/>
        </div>
    )
}

export default InvoicesTableSection;
